import React from "react";
import "./QueryPageMob.scss";

const QueryPageMob = () => {
  return (
    <div className="query-page-main-mb">
      <div className="qp-cont-outside-mb">
        <div className="qp-cont-mb">
          {/* <h2>QueryPage</h2> */}
          <div className="qp-inside1-mb">
            <p className="qp-p-mb">QUERIES?</p>
            <h2 className="qp-h2-mb">Feel free to Contact Us</h2>
            <div className="input-btn-div-mb">
              <input
                className="input-shash-mb"
                type="number"
                placeholder="Enter your Contact Number "
                name=""
                id=""
              />
              <button className="input-btn-mb">Get Started</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueryPageMob;
